import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable } from "rxjs";
import { USER_URL } from "../shared/src";
import { ErrorHandlerService } from "./error-handler.service";

@Injectable({
    providedIn: 'root',
})

export class AssignLeaveTypeService {
    private readonly ASSIGN_LEAVE_API = `${USER_URL}`;
    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    public assignLeaveTypeGetAll(
        pageIndex: number,
        pageSize: number,
        searchFilter?: string,
        countryId?: number | null
    ): Observable<any> {
        let url = `${this.ASSIGN_LEAVE_API}/assignLeaveType/getAll?pageIndex=${pageIndex}&pageSize=${pageSize}`;

        if (searchFilter) {
            url += `&searchFilter=${searchFilter}`;
        }

        if (countryId) {
            url += `&countryId=${countryId}`;
        }

        return this.http
            .get<any>(url)
            .pipe(catchError(this.errorHandler.handleError));
    }

    //To store the leave type
    public addLeaveType(leaveType: any): Observable<any> {
        return this.http
            .post<any>(`${this.ASSIGN_LEAVE_API}/assignLeaveType/save`, leaveType)
            .pipe(catchError(this.errorHandler.handleError));
    }


    public updateLeaveType(leaveType: any): Observable<any> {
        return this.http
            .put<any>(`${this.ASSIGN_LEAVE_API}/assignLeaveType/update`, leaveType)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public deleteLeaveType(id: number): Observable<string> {
        return this.http
            .delete<string>(`${this.ASSIGN_LEAVE_API}/assignLeaveType/delete/${id}`)
            .pipe(catchError(this.errorHandler.handleError));
    }
}